"use client"

import { Link } from "react-router-dom"
import {
  ArrowLeft,
  Mail,
  FileText,
  AlertTriangle,
  Heart,
  Scale,
  Users,
  Shield,
  Sparkles,
  Instagram,
} from "lucide-react"
import "./HomePage.css"

const LegalPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50">
      {/* Header */}
      <header className="container mx-auto px-4 py-6 flex items-center justify-between border-b border-gray-100">
        <Link to="/" className="flex items-center gap-3 no-underline">
          <img src="/assets/icon.png" alt="whatsin? logo" className="rounded-xl w-12 h-12 shadow-lg" />
          <span className="text-2xl font-bold">
            <span style={{ color: "#ff9f43" }}>whatsin</span>
            <span style={{ color: "#ff9f43" }}>?</span>
          </span>
        </Link>
        <Link
          to="/"
          className="inline-flex items-center gap-3 text-white px-6 py-3 rounded-lg font-semibold transition-all hover:shadow-lg hover:scale-105 no-underline"
          style={{ backgroundColor: "#ff9f43" }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#e8873a")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#ff9f43")}
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="hidden sm:inline">Ana Sayfa</span>
          <span className="sm:hidden">Geri</span>
        </Link>
      </header>

      {/* Legal Content */}
      <section className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Hero Section */}
          <div className="text-center space-y-8 mb-20">
            <div
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium shadow-sm"
              style={{ backgroundColor: "#fff7ed", color: "#ff9f43" }}
            >
              <FileText className="w-4 h-4" />📋 Kullanım Koşulları & Bilgilendirme
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-800">
              <span style={{ color: "#ff9f43" }}>whatsin?</span> Nasıl Çalışır?
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Ürünleri nasıl analiz ettiğimizi ve değerlendirme kriterlerimizi öğrenin! 🌟
            </p>
          </div>

          {/* Important Warnings */}
          <div
            className="mb-12 p-6 bg-gradient-to-r from-amber-50 to-orange-50 border-l-4 rounded-xl shadow-lg"
            style={{ borderColor: "#ff9f43" }}
          >
            <div className="flex items-start gap-4">
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md"
                style={{ backgroundColor: "#ff9f43" }}
              >
                <AlertTriangle className="w-6 h-6 text-white" />
              </div>
              <div className="space-y-3">
                <h3 className="text-xl font-bold" style={{ color: "#ff9f43" }}>
                  ⚠️ Önemli Uyarılar
                </h3>
                <div className="text-gray-700 space-y-2 leading-relaxed">
                  <p>
                    • <strong>Bilgi Doğruluğu:</strong> Uygulamamızda yer alan ürün analizleri büyük özenle
                    hazırlanmasına rağmen, tüm bilgilerin %100 doğru olduğu garanti edilemez.
                  </p>
                  <p>
                    • <strong>Tıbbi Tavsiye Değildir:</strong> Ürün analizlerimiz bilgilendirme amaçlıdır ve tıbbi
                    tavsiye yerine geçmez. Cilt problemleri için mutlaka uzman doktora danışın.
                  </p>
                  <p>
                    • <strong>Sorumluluk Sınırı:</strong> whatsin? uygulaması, verilen bilgilere dayanarak yapılan ürün
                    seçimlerinden kaynaklanan herhangi bir zarardan sorumlu tutulamaz.
                  </p>
                  <p>
                    • <strong>Patch Test Önerisi:</strong> Yeni ürün kullanımından önce mutlaka patch test yapmanızı
                    önemle tavsiye ederiz.
                  </p>
                  <p>
                    • <strong>Güncel Bilgi:</strong> Ürün formülleri üreticiler tarafından değiştirilebilir. En güncel
                    bilgi için ürün etiketini kontrol edin.
                  </p>
                  <p>
                    • <strong>Sahte Kampanyalar:</strong> whatsin? adı ve logosu kullanılarak yapılan sahte kampanya ve
                    satışların bizimle hiçbir ilgisi yoktur.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Items */}
          <div className="space-y-6">
            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all">
              <div className="flex items-start gap-6">
                <div
                  className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md"
                  style={{ backgroundColor: "#fff7ed" }}
                >
                  <Heart className="w-8 h-8" style={{ color: "#ff9f43" }} />
                </div>
                <div className="space-y-4">
                  <h3 className="text-xl font-bold text-gray-700">💚 whatsin? Hakkında</h3>
                  <div className="text-gray-600 leading-relaxed space-y-3">
                    <p>
                      whatsin?, kozmetik ürünlerin içeriklerini analiz ederek size en uygun seçimleri yapmanızda
                      yardımcı olan bağımsız bir uygulamadır.
                    </p>
                    <p>
                      Hiçbir marka veya üretici ile ticari bağlantımız yoktur. Amacımız, size objektif ve bilimsel
                      temelli bilgiler sunmaktır.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all">
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-400 to-blue-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md">
                  <Scale className="w-8 h-8" />
                </div>
                <div className="space-y-4">
                  <h3 className="text-xl font-bold text-gray-700">🔬 Ürünleri Nasıl Değerlendiriyoruz?</h3>
                  <p className="text-gray-600 leading-relaxed">Ürün analizlerimiz aşağıdaki kriterlere dayanır:</p>
                  <div className="text-gray-600 leading-relaxed space-y-2">
                    <p>
                      • <strong>İçerik Güvenliği:</strong> AB düzenlemeleri ve EWG verilerine göre bileşenlerin güvenirlik
                      durumu
                    </p>
                    <p>
                      • <strong>Alerjen Riski:</strong> Bilinen alerjen maddelerin varlığı ve potansiyel etkileri
                    </p>
                    <p>
                      • <strong>Çevresel Etki:</strong> Sürdürülebilirlik ve çevre dostu bileşenlerin değerlendirilmesi
                    </p>
                    <p>
                      • <strong>Tartışmalı Maddeler:</strong> Bilimsel toplulukta tartışma konusu olan bileşenlerin
                      işaretlenmesi
                    </p>
                    <p>
                      • <strong>Cilt Tipi Uygunluğu:</strong> Farklı cilt tiplerinin ihtiyaçlarına göre uygunluk analizi
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all">
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 bg-gradient-to-br from-green-400 to-green-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md">
                  <FileText className="w-8 h-8 text-white" />
                </div>
                <div className="space-y-4">
                  <h3 className="text-xl font-bold text-gray-700">📚 Bilgi Kaynaklarımız</h3>
                  <div className="text-gray-600 leading-relaxed space-y-3">
                    <p>Analizlerimizde kullandığımız bilgi kaynakları:</p>
                    <div className="space-y-2">
                      <p>• Halka açık ürün veritabanları ve resmi kayıtlar</p>
                      <p>• Peer-reviewed bilimsel araştırmalar ve yayınlar</p>
                      <p>• AB, FDA ve diğer düzenleyici kurum verileri</p>
                      <p>• Üretici tarafından sağlanan güncel ürün bilgileri</p>
                    </div>
                    <p className="text-sm text-gray-500 italic mt-3">
                      💡 <strong>Not:</strong> Tüm bilgiler sürekli güncellenmekte ve yeni araştırmalara göre revize
                      edilmektedir.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all">
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md">
                  <Sparkles className="w-8 h-8 text-white" />
                </div>
                <div className="space-y-4">
                  <h3 className="text-xl font-bold text-gray-700">👤 Kullanıcılar İçin Önemli Bilgiler</h3>
                  <div className="text-gray-600 leading-relaxed space-y-3">
                    <p>whatsin? uygulamasını kullanırken lütfen şunları unutmayın:</p>
                    <div className="space-y-2">
                      <p>
                        📖 Uygulamamız <strong>bilgilendirme amaçlıdır</strong> ve tıbbi tavsiye niteliği taşımaz
                      </p>
                      <p>
                        👩‍⚕️ Cilt problemleri veya alerjileriniz varsa <strong>mutlaka bir uzman</strong>a danışın
                      </p>
                      <p>
                        🔍 Hassas cildiyseniz ürünü kullanmadan önce <strong>patch test</strong> yapmanızı öneririz
                      </p>
                      <p>
                        📱 Uygulama sürekli geliştirilmekte, <strong>güncel sürümü</strong> kullandığınızdan emin olun
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all">
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 bg-gradient-to-br from-indigo-400 to-indigo-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md">
                  <Shield className="w-8 h-8" />
                </div>
                <div className="space-y-4">
                  <h3 className="text-xl font-bold text-gray-700">🔒 Kişisel Veri Kullanımı</h3>
                  <div className="text-gray-600 leading-relaxed space-y-3">
                    <p>
                      Hesap oluştururken paylaştığınız kişisel bilgiler (cilt tipi, saç tipi, yaş, cinsiyet vb.)
                      yalnızca size özel ürün analizleri ve öneriler sunmak için kullanılır.
                    </p>
                    <div className="space-y-2">
                      <p>• Verileriniz şifrelenerek güvenli sunucularda saklanır</p>
                      <p>• Hiçbir kişisel veri üçüncü taraflarla paylaşılmaz</p>
                      <p>• İstediğiniz zaman hesabınızı ve verilerinizi silebilirsiniz</p>
                      <p>• Veriler yalnızca kişiselleştirilmiş analiz için kullanılır</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all">
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 bg-gradient-to-br from-purple-400 to-purple-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md">
                  <Users className="w-8 h-8 text-white" />
                </div>
                <div className="space-y-4">
                  <h3 className="text-xl font-bold text-gray-700">🏢 Markalar İçin Bilgilendirme</h3>
                  <div className="text-gray-600 leading-relaxed space-y-3">
                    <p>Marka temsilcileri ve üreticiler için:</p>
                    <div className="space-y-2">
                      <p>
                        📝 Ürün bilgilerinizi güncellemek için bizimle <strong>iletişime geçebilirsiniz</strong>
                      </p>
                      <p>
                        ✏️ Yanlış veya eksik bilgiler için <strong>düzeltme talebinde</strong> bulunabilirsiniz
                      </p>
                      <p>
                        📊 Analizlerimiz hakkında <strong>görüş ve önerilerinizi</strong> paylaşabilirsiniz
                      </p>
                      <p>
                        🔄 Yeni ürün lansmanlarınızı <strong>zamanında yansıtmak</strong> için bilgi verebilirsiniz
                      </p>
                    </div>
                    <p className="font-semibold text-gray-800 mb-2">
                      📧 Marka İletişim:
                      <a
                        href="mailto:ebruipekaktukmak@gmail.com?subject=Marka%20Talebi%20-%20whatsin?"
                        className="font-semibold hover:underline transition-colors no-underline ml-2"
                        style={{ color: "#ff9f43" }}
                      >
                        ebruipekaktukmak@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div
            className="text-center mt-20 p-12 rounded-2xl"
            style={{ background: "linear-gradient(135deg, #ff9f43 0%, #f7931e 50%, #e8873a 100%)" }}
          >
            <div className="space-y-8 text-white">
              <div className="w-24 h-24 mx-auto bg-white/20 rounded-2xl flex items-center justify-center">
                <Mail className="w-12 h-12" />
              </div>
              <h2 className="text-4xl font-bold">Sorularınız mı Var?</h2>
              <p className="text-xl opacity-90 max-w-2xl mx-auto">
                Uygulama hakkında merak ettikleriniz, önerileriniz veya marka bilgi güncellemeleri için bizimle
                iletişime geçin! 💌
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="mailto:ebruipekaktukmak@gmail.com"
                  className="inline-flex items-center gap-3 bg-white hover:bg-gray-100 px-8 py-4 text-lg font-semibold rounded-2xl shadow-lg hover:shadow-xl transition-all hover:scale-105 no-underline"
                  style={{ color: "#ff9f43" }}
                >
                  <Mail className="w-6 h-6" />
                  <span className="hidden sm:inline">Genel İletişim</span>
                  <span className="sm:hidden">İletişim</span>
                </a>
                <a
                  href="mailto:ebruipekaktukmak@gmail.com?subject=Marka%20Talebi%20-%20whatsin?"
                  className="inline-flex items-center gap-3 bg-white/20 border-2 border-white text-white hover:bg-white px-8 py-4 text-lg font-semibold rounded-2xl transition-all hover:scale-105 no-underline"
                  style={{ "--hover-color": "#ff9f43" }}
                  onMouseEnter={(e) => (e.target.style.color = "#ff9f43")}
                  onMouseLeave={(e) => (e.target.style.color = "white")}
                >
                  <Users className="w-6 h-6" />
                  <span className="hidden sm:inline">Marka Bilgi Güncelleme</span>
                  <span className="sm:hidden">Marka</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid sm:grid-cols-2 gap-8 items-center">
            <div className="space-y-4 text-center sm:text-left">
              <div className="flex items-center gap-3 justify-center sm:justify-start">
                <img src="/assets/icon.png" alt="whatsin? logo" className="rounded-lg w-10 h-10" />
                <span className="text-2xl font-bold text-white">
                  whatsin?
                </span>
              </div>
              <p className="text-gray-400">Güzellik dünyasında akıllı rehberin! 💄✨</p>
            </div>
            <div className="flex flex-wrap gap-4 justify-center sm:justify-end items-center">
              <a
                href="https://www.instagram.com/whatsin_app/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors no-underline flex items-center gap-2"
              >
                <Instagram className="w-5 h-5" />
                <span className="hidden sm:inline">Instagram</span>
              </a>
              <Link to="/" className="text-gray-400 hover:text-white transition-colors no-underline">
                Ana Sayfa
              </Link>
              <Link to="/support" className="text-gray-400 hover:text-white transition-colors no-underline">
                İletişim
              </Link>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
            <p>&copy; 2026 whatsin? Tüm hakları saklıdır. Made with 💖 for healthy living.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default LegalPage
